// src/components/dashboard/RecentActivity.tsx
import React from "react";

export const RecentActivity: React.FC = () => {
  const activities = [
    {
      id: 1,
      action: "New booking from John Doe",
      time: "2 hours ago",
      type: "booking",
    },
    {
      id: 2,
      action: 'Tour "Desert Safari" updated',
      time: "5 hours ago",
      type: "update",
    },
    {
      id: 3,
      action: "Payment received €450",
      time: "1 day ago",
      type: "payment",
    },
    {
      id: 4,
      action: "New customer registered",
      time: "2 days ago",
      type: "customer",
    },
  ];

  return (
    <div className="space-y-4">
      {activities.map((activity) => (
        <div
          key={activity.id}
          className="flex items-center justify-between pb-3 border-b border-gray-100 last:border-0"
        >
          <div>
            <p className="text-gray-800">{activity.action}</p>
            <span className="text-sm text-gray-500">{activity.time}</span>
          </div>
          <span
            className={`text-xs px-2 py-1 rounded-full ${
              activity.type === "booking"
                ? "bg-blue-100 text-blue-700"
                : activity.type === "payment"
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            {activity.type}
          </span>
        </div>
      ))}
    </div>
  );
};
